/** Aligns with Tailwind `lg`: desktop auth skips `/welcome` and uses concrete routes only. */
export const AUTH_DESKTOP_MIN_WIDTH_PX = 1024;

export function prefersAuthDesktop() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(`(min-width: ${AUTH_DESKTOP_MIN_WIDTH_PX}px)`).matches;
}

export function isAuthSurfacePath(pathname) {
  return pathname === '/welcome' || pathname === '/login' || pathname === '/register';
}

/** Routes that require a session — navigating here while logged out bounces back to `/login`. */
export function isAuthGuardRedirectTarget(pathname) {
  if (pathname === '/onboarding' || pathname === '/my-activities' || pathname === '/create' || pathname === '/profile') {
    return true;
  }
  return /^\/activity\/[^/]+\/edit$/.test(pathname);
}

/** Marketing “get started” / signup CTAs → `/register` on desktop, `/welcome` on smaller viewports. */
export function signupEntryPath() {
  return prefersAuthDesktop() ? '/register' : '/welcome';
}

/** Landing “Create an activity” (guests) → `/create` on desktop, `/welcome` on mobile. */
export function createActivityMarketingPath() {
  return prefersAuthDesktop() ? '/create' : '/welcome';
}

/** Guards, 401, missing session — always `/login` (mobile bottom nav → protected tabs included). */
export function unauthenticatedEntryPath() {
  return '/login';
}

/**
 * Login/register mobile header "Back": use `state.from` only when it is a public screen
 * (guarded URLs would immediately redirect to `/login` again). Otherwise browser back.
 */
export function resolveAuthChromeBack(locationState) {
  const from = locationState?.from;
  const pathname = from?.pathname;
  if (
    typeof pathname === 'string' &&
    pathname.length > 0 &&
    !isAuthSurfacePath(pathname) &&
    !isAuthGuardRedirectTarget(pathname)
  ) {
    return {
      mode: 'to',
      to: `${pathname}${from.search || ''}${from.hash || ''}`,
      state: from.state,
    };
  }
  return { mode: 'history' };
}